/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * Umbrella commercial contract acceptance requirement for this identity. The resource is absent when no umbrella acceptance state is available for the identity. Its absence must not be interpreted as required being false.
 * @export
 * @interface UmbrellaCommercialContractAcceptanceResource
 */
export interface UmbrellaCommercialContractAcceptanceResource {
    /**
     * 
     * @type {boolean}
     * @memberof UmbrellaCommercialContractAcceptanceResource
     */
    required: boolean;
}

/**
 * Check if a given object implements the UmbrellaCommercialContractAcceptanceResource interface.
 */
export function instanceOfUmbrellaCommercialContractAcceptanceResource(value: object): value is UmbrellaCommercialContractAcceptanceResource {
    if (!('required' in value) || value['required'] === undefined) return false;
    return true;
}

export function UmbrellaCommercialContractAcceptanceResourceFromJSON(json: any): UmbrellaCommercialContractAcceptanceResource {
    return UmbrellaCommercialContractAcceptanceResourceFromJSONTyped(json, false);
}

export function UmbrellaCommercialContractAcceptanceResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): UmbrellaCommercialContractAcceptanceResource {
    if (json == null) {
        return json;
    }
    return {
        
        'required': json['required'],
    };
}

export function UmbrellaCommercialContractAcceptanceResourceToJSON(value?: UmbrellaCommercialContractAcceptanceResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'required': value['required'],
    };
}

